import { render, staticRenderFns } from "./trainingAddView.vue?vue&type=template&id=0f20d21e"
import script from "./trainingAddView.vue?vue&type=script&lang=js"
export * from "./trainingAddView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports